export const APP_VERSION = '1.5.0';
